import { useEffect, useRef, useState } from "react";

import { Icon } from "../components/Icon.jsx";
import { DRIVER_NOTIFICATION_EVENT } from "./driver-notifications.js";

const ICON_BY_TONE = {
  success: "check",
  error: "warning",
  warning: "warning",
  info: "bell",
};

export function DriverToastHost() {
  const [notices, setNotices] = useState([]);
  const timersRef = useRef(new Map());

  useEffect(() => {
    function dismiss(id) {
      const timer = timersRef.current.get(id);
      if (timer) window.clearTimeout(timer);
      timersRef.current.delete(id);
      setNotices((current) => current.filter((notice) => notice.id !== id));
    }

    function handleNotification(event) {
      const notice = event.detail;
      if (!notice?.message) return;

      setNotices((current) => {
        const withoutDuplicate = current.filter((item) => item.message !== notice.message || item.tone !== notice.tone);
        return [...withoutDuplicate, notice]
          .sort((left, right) => Number(right.priority || 0) - Number(left.priority || 0) || Number(left.createdAt || 0) - Number(right.createdAt || 0))
          .slice(0, 2);
      });

      const existingTimer = timersRef.current.get(notice.id);
      if (existingTimer) window.clearTimeout(existingTimer);
      timersRef.current.delete(notice.id);
      if (!notice.persistent) {
        timersRef.current.set(notice.id, window.setTimeout(() => dismiss(notice.id), notice.duration));
      }
    }

    window.addEventListener(DRIVER_NOTIFICATION_EVENT, handleNotification);
    return () => {
      window.removeEventListener(DRIVER_NOTIFICATION_EVENT, handleNotification);
      for (const timer of timersRef.current.values()) window.clearTimeout(timer);
      timersRef.current.clear();
    };
  }, []);

  function dismiss(id) {
    const timer = timersRef.current.get(id);
    if (timer) window.clearTimeout(timer);
    timersRef.current.delete(id);
    setNotices((current) => current.filter((notice) => notice.id !== id));
  }

  if (!notices.length) return null;

  return (
    <div aria-live="polite" aria-relevant="additions" className="driver-toast-region">
      {notices.map((notice) => (
        <section
          className={`driver-toast is-${notice.tone}${notice.compact ? " is-compact" : ""}`}
          key={notice.id}
          role={notice.tone === "error" ? "alert" : "status"}
        >
          <span className="driver-toast__icon" aria-hidden="true">
            <Icon name={notice.icon || ICON_BY_TONE[notice.tone] || "bell"} size={18} />
          </span>
          <div className="driver-toast__content">
            {notice.title && <strong>{notice.title}</strong>}
            <p>{notice.message}</p>
          </div>
          {notice.dismissible !== false && (
            <button aria-label="Tutup notifikasi" onClick={() => dismiss(notice.id)} type="button">
              <Icon name="close" size={16} />
            </button>
          )}
        </section>
      ))}
    </div>
  );
}
